<template>
  <transition name="scale-transition">
    <div v-show="showFab" class="fab-container px-5 d-lg-none">
      <v-toolbar class="br-4 px-0 justify-space-between bg-tr">
        <v-btn icon to="/controllers">
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
        <v-btn icon :to="'/dashboard/' + controllerId">
          <v-icon>mdi-gauge</v-icon>
        </v-btn>

        <v-btn v-if="notificationsCount > 0" icon :to="'/notifications/' + controllerId">
          <v-badge overlap color="primary">
            <template v-slot:badge>{{ notificationsCount }}</template>
              <v-icon>mdi-bell-ring-outline</v-icon>
          </v-badge>
        </v-btn>
        <v-btn v-else icon :to="'/notifications/' + controllerId">
          <v-icon>mdi-bell-ring</v-icon>
        </v-btn>

        <v-btn icon :to="'/stats/' + controllerId">
          <v-icon>mdi-poll</v-icon>
        </v-btn>
        
        <v-btn v-if="permission == 0" icon :to="'/users/' + controllerId">
          <v-icon>mdi-account-multiple</v-icon>
        </v-btn>
        <v-btn v-else icon>
          <v-icon color="info">mdi-account-multiple</v-icon>
        </v-btn>

        <v-btn icon :to="'/controller/' + controllerId">
          <v-icon>mdi-settings</v-icon>
        </v-btn>
      </v-toolbar>
    </div>
  </transition>
</template>

<script>
import ControllerCard from './../components/ControllerCard.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    showFab: false
  }),
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    permission() {
      if (typeof this.$store.state[this.moduleName] === 'object') {
        return (typeof this.$store.state[this.moduleName].params === 'object' && this.$store.state[this.moduleName].params !== null) ? this.$store.state[this.moduleName].params.permission : undefined
      } else {
        return undefined
      }
    },
    notificationsCount() {
      return this.$store.getters['notifications/countByController'](this.controllerId)
    }
  },
  mounted () {
    setTimeout(() => { this.showFab = true; }, 300);
  },
}
</script>

<style>
  .v-toolbar.justify-space-between .v-toolbar__content {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
  .theme--light.v-sheet.bg-tr {
    background-color: rgba(255,255,255,0.9) !important;
    border: 1px solid rgba(0,0,0,0.1);
  }
</style>